'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { clearRuntimeLogContext, setRuntimeLogContext } from '@colix/frontend-logger'

const USER_CONTEXT_KEYS = ['user_id', 'user_role']

export function LoggerUserContext() {
  const { data: session } = useSession()

  useEffect(() => {
    const user = session?.user

    if (!user?.id) {
      clearRuntimeLogContext(USER_CONTEXT_KEYS)
      return
    }

    setRuntimeLogContext({
      user_id: user.id,
      user_role: user.role,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only re-run when id or role changes, not the full user object
  }, [session?.user?.id, session?.user?.role])

  return null
}
